import VuexCommonMix from '@/store/vuexCommonMix'
import { queryCourseBySeller, checkLogin, querySummary } from '@/api'
import moment from 'moment'
export default {
  components: {},
  mixins: [VuexCommonMix],
  props: [],
  name: 'home-page',
  data () {
    return {
      searchText: '',
      active: 0,
      loading: false,
      finished: false,
      typeChoose: 1,
      directionChoose: null,
      allNum: null,
      allPage: null,
      currentPage: 1,
      courseList: [],
      startMonthRange: null,
      show: false,
      actions: [
        { name: '第一季度', startMonthRange: { start: 1, end: 3 } },
        { name: '第二季度', startMonthRange: { start: 4, end: 6 } },
        { name: '第三季度', startMonthRange: { start: 7, end: 9 } },
        { name: '第四季度', startMonthRange: { start: 10, end: 12 } }
      ],
      searchCourseList: []
    }
  },
  computed: {
    pageTypeList: function () {
      return [
        { text: '国内小组科研', value: [6], index: 1 },
        { text: '国外小组科研', value: [1], index: 2 },
        { text: '1V1', value: [2, 3], index: 3 },
        { text: '其他项目', value: [4, 5], index: 4 }
      ]
    },
    pageDirectionList: function () {
      return [
        { text: '金融商科', value: 7 },
        { text: '理工', value: 11 },
        { text: '人文社科', value: 17 }
        // { text: '艺术', value: 23 }
      ]
    }
  },
  watch: {
    // x: function(val) {}
  },
  created () {
    this.active = this.$route.query.active ? this.$route.query.active * 1 : 0
  },
  mounted () {
    if (this.active === 0) {
      this.initVuex().then(() => { this.initPageData() })
    } else if (this.active === 1) {
      this.initVuex().then(() => { this.initSearchData() })
    }
  },
  destroyed () {},
  methods: {
    async initVuex () {
      this.loading = true
      const { error, data } = await checkLogin()
      if (error.returnCode === 0) {
        await this.initUserInfo(data)
        const { data: summaryInfo } = await querySummary()
        await this.initExtendInfo({ summaryInfo })
      }
    },
    async initPageData () {
      if (this.isLogin) {
        const param = {
          limit: 100,
          page: this.currentPage,
          orderBy: [{
            orderName: 'schoolBegins'
          }],
          startYear: moment().format('YYYY') * 1
        }
        if (this.typeChoose) {
          param.type = this.pageTypeList.filter((item) => { return item.index === this.typeChoose })[0].value
        }
        if (this.directionChoose) { param.directionId = String(this.directionChoose) }
        if (this.startMonthRange) { param.startMonthRange = this.startMonthRange }
        const { data } = await queryCourseBySeller(param)

        this.allNum = data.allNum
        this.allPage = data.allPage
        this.currentPage = data.currentPage
        if (this.currentPage !== 1) {
          this.courseList = this.courseList.concat(data.courseList)
        } else {
          this.courseList = data.courseList
        }
      } else {
        this.$router.push('/login')
      }
      this.loading = false
    },
    chooseSideItem (item) {
      this.finished = false
      if (item.value === this.directionChoose) {
        this.directionChoose = null
      } else {
        this.directionChoose = item.value
      }
      this.currentPage = 1
      this.$refs.table.scrollTop = 0
      this.initPageData()
    },
    chooseHeaderItem (item) {
      if (item.index === this.typeChoose) {
        this.typeChoose = null
      } else {
        this.typeChoose = item.index
      }
      this.directionChoose = null
      this.currentPage = 1
      this.finished = false
      this.$refs.table.scrollTop = 0
      console.log('this.$refs.table: ', this.$refs.table.scrollTop)
      this.initPageData()
    },
    onLoad () {
      if (this.currentPage >= this.allPage) { this.finished = true; return }
      this.currentPage++
      this.loading = false
      this.initPageData()
    },
    onSelect (item) {
      this.show = false
      this.startMonthRange = item.startMonthRange
      this.currentPage = 1
      this.finished = false
      this.$refs.table.scrollTop = 0
      this.initPageData()
    },
    onCancel () {
      this.show = false
      this.startMonthRange = null
      this.currentPage = 1
      this.finished = false
      this.$refs.table.scrollTop = 0
      this.initPageData()
    },
    toAttachment (item) {
      this.$router.push({ path: '/attachment', query: { id: item.id } })
    },
    toDetail (item) {
      this.$router.push({ path: '/detail', query: { id: item.id } })
    },
    timeFormat (startTime, endTime) {
      if (startTime === null) return '人满开班'
      else if (endTime === null) return moment(startTime).format('MM月DD日')
      else return `${moment(startTime).format('MM月DD日')}至${moment(endTime).format('MM月DD日')}`
    },
    bottomChange () {
      this.$router.push({ path: '/home', query: { active: this.active } })
      this.searchText = ''
      this.currentPage = 1
      this.finished = false
      this.allPage = null
      if (this.active === 0) { this.initPageData() }
      if (this.active === 1) { this.initSearchData() }
    },
    onSearchLoad () {
      if (this.searchCourseList.length === 0) { this.loading = false; return }
      if (this.currentPage >= this.allPage) { this.finished = true; this.loading = false; return }
      this.currentPage++
      this.loading = true
      this.initSearchData()
    },
    onSearch () {
      this.currentPage = 1
      this.allPage = null
      this.finished = false
      this.loading = false
      this.searchCourseList = []
      this.initSearchData()
    },
    async initSearchData () {
      const param = {
        limit: 100,
        mergeMajorCourseSearch: this.searchText,
        page: this.currentPage,
        orderBy: [{ orderName: 'schoolBegins' }],
        startYear: moment().format('YYYY') * 1
      }
      const { data } = await queryCourseBySeller(param)
      this.allNum = data.allNum
      this.allPage = data.allPage
      this.currentPage = data.currentPage
      if (this.currentPage !== 1) {
        this.searchCourseList = this.searchCourseList.concat(data.courseList)
      } else {
        this.searchCourseList = data.courseList
      }
      this.loading = false
    }
  }
}
